/* Talas site chat launcher + panel. Markup: snippets/talas-chat.liquid. Styles: assets/talas-chat.css.
   respond.io is loaded only when "Chat on website" is clicked, then driven through its documented $respond API. */
(function () {
  'use strict';
  var doc = document, html = doc.documentElement;
  var root = doc.getElementById('tchat');
  if (!root) return;
  var fab = root.querySelector('[data-tchat-fab]');
  var panel = root.querySelector('[data-tchat-panel]');
  var list = root.querySelector('[data-tchat-list]');
  var web = root.querySelector('[data-tchat-web]');
  var note = root.querySelector('[data-tchat-note]');
  if (!fab || !panel || !list) return;
  var isOpen = false, hideTimer = 0;

  function reduced() { return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches; }

  /* closest branch: sessionStorage "talas_geo" ({la, lo}) is written by the pickup drawer / contact page */
  function readGeo() {
    try { var v = JSON.parse(sessionStorage.getItem('talas_geo')); return v && isFinite(v.la) && isFinite(v.lo) ? { la: Number(v.la), lo: Number(v.lo) } : null; } catch (e) { return null; }
  }
  function km(a, b, c, d) {
    var r = function (x) { return x * Math.PI / 180; };
    var x = Math.pow(Math.sin(r(c - a) / 2), 2) + Math.cos(r(a)) * Math.cos(r(c)) * Math.pow(Math.sin(r(d - b) / 2), 2);
    return 12742 * Math.asin(Math.sqrt(x));
  }
  function markClosest() {
    var g = readGeo();
    if (!g) return;
    var rows = [].slice.call(list.querySelectorAll('[data-lat]')), best = null, bd = Infinity;
    rows.forEach(function (r) {
      var d = km(g.la, g.lo, parseFloat(r.getAttribute('data-lat')), parseFloat(r.getAttribute('data-lng')));
      if (d < bd) { bd = d; best = r; }
    });
    if (!best) return;
    rows.forEach(function (r) { var t = r.querySelector('[data-tchat-tag]'); if (t) t.hidden = r !== best; });
    if (list.firstElementChild !== best) list.insertBefore(best, list.firstElementChild);
  }

  function focusables() {
    return [].slice.call(panel.querySelectorAll('a[href],button:not([disabled])')).filter(function (e) { return e.offsetParent !== null; });
  }
  function open() {
    if (isOpen) return;
    isOpen = true;
    clearTimeout(hideTimer);
    markClosest();
    panel.hidden = false;
    void panel.offsetWidth;
    root.classList.add('is-open');
    fab.setAttribute('aria-expanded', 'true');
    var f = focusables();
    if (f[0]) f[0].focus({ preventScroll: true });
  }
  function close(restoreFocus) {
    if (!isOpen) return;
    isOpen = false;
    root.classList.remove('is-open');
    fab.setAttribute('aria-expanded', 'false');
    if (reduced()) panel.hidden = true; else hideTimer = setTimeout(function () { panel.hidden = true; }, 220);
    if (restoreFocus) fab.focus({ preventScroll: true });
  }

  fab.addEventListener('click', function () { if (isOpen) close(true); else open(); });
  root.querySelector('[data-tchat-close]').addEventListener('click', function () { close(true); });
  doc.addEventListener('keydown', function (e) {
    if (!isOpen) return;
    if (e.key === 'Escape') { e.preventDefault(); close(true); return; }
    if (e.key !== 'Tab') return;
    var f = focusables().concat(fab);
    var first = f[0], last = f[f.length - 1], a = doc.activeElement;
    if (e.shiftKey && (a === first || !root.contains(a))) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && (a === last || !root.contains(a))) { e.preventDefault(); first.focus(); }
  });
  doc.addEventListener('pointerdown', function (e) { if (isOpen && !root.contains(e.target)) close(false); });
  /* a drawer / modal locking the page closes the panel */
  if (window.MutationObserver) new MutationObserver(function () { if (html.classList.contains('overflow-hidden')) close(false); }).observe(html, { attributes: true, attributeFilter: ['class'] });

  /* ---- respond.io (web chat backend), loaded on demand ---- */
  var rioBusy = false, rioOpened = false, rioBound = false;
  function setNote(kind) {
    if (!note) return;
    note.textContent = kind ? note.getAttribute('data-' + kind) : '';
    note.classList.toggle('is-error', kind === 'failed');
    if (web) web.setAttribute('aria-busy', kind === 'loading' ? 'true' : 'false');
  }
  function rioReady() { return window.$respond && typeof window.$respond.do === 'function'; }
  function onOpened() { rioOpened = true; rioBusy = false; html.classList.add('tchat-rio-on'); setNote(''); close(false); }
  function onClosed() { rioOpened = false; html.classList.remove('tchat-rio-on'); }
  function bind() {
    if (rioBound) return;
    rioBound = true;
    try { window.$respond.on('chat:opened', onOpened); window.$respond.on('chat:closed', onClosed); } catch (e) {}
  }
  function fail() { rioBusy = false; setNote('failed'); }
  function tryOpen(n) {
    if (rioOpened) return;
    var is = false;
    try { is = window.$respond.is('chat:open'); } catch (e) {}
    if (is) { onOpened(); return; }
    if (n > 8) { fail(); return; }
    try { window.$respond.do('chat:open'); } catch (e) {}
    setTimeout(function () { tryOpen(n + 1); }, 700);
  }
  function whenReady(n) {
    if (rioReady()) { bind(); tryOpen(0); return; }
    if (n > 100) { fail(); return; }
    setTimeout(function () { whenReady(n + 1); }, 100);
  }
  /* respond.io names its iframe "Webchat Widget" (shows as a native tooltip): re-title it and tag it for our CSS / liftChat */
  var titleMO;
  function retitle() {
    var t = root.getAttribute('data-rio-title') || '';
    [].forEach.call(doc.querySelectorAll('iframe[title="Webchat Widget"],iframe[data-tchat-rio]'), function (f) {
      if (!f.hasAttribute('data-tchat-rio')) f.setAttribute('data-tchat-rio', '');
      if (t && f.getAttribute('title') !== t) f.setAttribute('title', t);
    });
  }
  function watchTitle() {
    if (titleMO || !window.MutationObserver) return;
    titleMO = new MutationObserver(retitle);
    titleMO.observe(doc.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['title'] });
    retitle();
  }
  function loadRio() {
    watchTitle();
    var src = root.getAttribute('data-rio-src');
    if (!/^https:\/\/cdn\.respond\.io\//.test(src || '')) { fail(); return; }
    var s = doc.createElement('script'), old = doc.getElementById('respondio__widget');
    s.id = 'respondio__widget'; s.async = true; s.src = src;
    s.onload = function () { whenReady(0); };
    s.onerror = fail;
    if (old) old.replaceWith(s); else doc.body.appendChild(s);
  }
  if (web) web.addEventListener('click', function () {
    if (rioBusy) return;
    rioBusy = true;
    if (rioReady()) { close(false); bind(); tryOpen(0); return; }
    setNote('loading');
    loadRio();
  });
})();
